export default "<svg viewBox=\"0 0 14.707 14.707\">\n        <rect x=\"6.275\" y=\"0\" width=\"2.158\" height=\"14.707\" />\n      </svg>";